import { Box, Flex } from '@mantine/core'
import dayjs from 'dayjs'

import { Button } from '@/components/Button/Button'
import { NumberInput } from '@/components/NumberInput/NumberInput'
import { SeparateDateInput } from '@/components/SeparateDateInput/SeparateDateInput'
import type { ValueChangeItemProps } from '@/components/ValueChangeItem/ValueChangeItem.types'

import classes from './ValueChangeItem.module.css'

export function ValueChangeItem({ form, index }: ValueChangeItemProps) {
  const handleChange = (value: Date | undefined) => {
    if (value) {
      form.setFieldValue(`valueChanges.${index}.date`, value.toISOString())
    }
  }

  return (
    <Box className={classes.box}>
      <SeparateDateInput
        disableFutureDates
        label="Date"
        onChange={value =>
          handleChange(value instanceof Date ? value : undefined)
        }
        value={
          form.values.valueChanges?.[index]?.date
            ? dayjs(form.values.valueChanges[index].date).toDate()
            : undefined
        }
      />

      <Flex align="flex-end" gap={16} justify="space-between">
        <Box flex={1}>
          <NumberInput
            hideControls
            label="New Value"
            {...form.getInputProps(`valueChanges.${index}.value`)}
          />
        </Box>

        <Button
          mb={16}
          miw={1}
          onClick={() => form.removeListItem('valueChanges', index)}
          variant="error"
        >
          Remove
        </Button>
      </Flex>
    </Box>
  )
}
